<template>
  <div class="admin-home">
    <admin-header></admin-header>
    <router-view id="site-content"></router-view>
  </div>
</template>

<script>
import AdminHeader from '../components/AdminHeader'

export default {
  name: 'AdminHome',
  components: {
    AdminHeader
  }
}
</script>

<style lang="scss" scoped>
.admin-home {
  display: flex;
  flex-direction: column;
}

#admin-header {
  flex-shrink: 0;
}

#site-content {
  flex-grow: 1;
}
</style>